define('LNRS/Track/TrackScroll',["jquery", "Track/DataLayerManager"], function ($, dlmanager) {

    var minHeight = 600,
        $window = $(window),
        cache = [],
        eventName = "scroll.tracker";

    // Throttle function from: Underscore.js 1.5.2  http://underscorejs.org
    function throttle(func, wait) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        var later = function () {
            previous = new Date;
            timeout = null;
            result = func.apply(context, args);
        };
        return function () {
            var now = new Date;
            if (!previous) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0) {
                clearTimeout(timeout);
                timeout = null;
                previous = now;
                result = func.apply(context, args);
            } else if (!timeout) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    }

    // Code adapted from https://github.com/robflaherty/jquery-scrolldepth/blob/master/jquery.scrolldepth.js
    return function trackScroll() {

        // Return early if document height is too small
        if ($(document).height() < minHeight) {
            return;
        }

        function sendEvent(milestone) {
            var o = {
                site_events: { page_scroll: "true" },
                scroll_quartile: milestone,
                event_name: "page scrolling milestone"
            };

            dlmanager.trackAnalytics(o);
        }

        function calculateMarks(docHeight) {
            return {
                '1': parseInt(docHeight * 0.25, 10), // 25%
                '2': parseInt(docHeight * 0.50, 10), // 50%
                '3': parseInt(docHeight * 0.75, 10), // 75%
                // Cushion to trigger 100% event in iOS
                '4': docHeight - 5 // 100%
            };
        }

        function checkMarks(marks, scrollDistance) {
            // Check each active mark
            $.each(marks, function (key, val) {
                if ($.inArray(key, cache) === -1 && scrollDistance >= val) {
                    sendEvent(key);
                    cache.push(key);
                }
            });
        }

        $window.on(eventName, throttle(function () {
            // We calculate document and window height on each scroll event
            // to account for dynamic DOM changes.

            var docHeight = $(document).height(),
              winHeight = window.innerHeight ? window.innerHeight : $window.height(),
              scrollDistance = $window.scrollTop() + winHeight,
              marks = calculateMarks(docHeight);

            // If all marks already hit, unbind scroll event
            if (cache.length >= 4) {
                $window.off(eventName);
                return;
            }

            checkMarks(marks, scrollDistance);
        }, 500));
    };
});
